export const ModelName = (window['ModelName'] ? window['ModelName'] : '');

const SALESFORCE_MODEL_NAME_CORRECTIONS = {
  "All-new Outback": "All-new OutbackOutback AWD",
  "All-new Outback Wilderness": "All-new OutbackOutback AWD Wilderness",
};

export function toSFModelName(modelName: string): string {
  return SALESFORCE_MODEL_NAME_CORRECTIONS[modelName] || modelName;
}